<template>
  <div>
    <el-row :gutter="5">
      <el-col :span="16" :xs="12">
        <el-card>
          <div class="card">
            <div>
              <img :src="userInfo.headImage" alt="用户图片" />
            </div>
            <div>
              <div>{{ userInfo.nickName }} (ID:{{ userInfo.id }})</div>
              <div>注册时间:{{ timeFormat(userInfo.creatTime) }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8" :xs="12">
        <el-card style="height: 120px; text-align: center">
          <div class="dredge">
            <el-button type="primary" @click="addMonth">开通充电包月</el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :span="8" :xs="8">
        <el-card> 余额(元): {{ userInfo.money }} </el-card>
      </el-col>
      <el-col :span="8" :xs="8">
        <el-card> 充值时长: {{ userInfo.grandTotalChargedNum }} </el-card>
      </el-col>
      <el-col :span="8" :xs="8">
        <el-card> 累计充值(元): {{ userInfo.grandTotalMoney }} </el-card>
      </el-col>
    </el-row>
    <el-tabs type="border-card">
      <el-tab-pane label="包月套餐">
        <user-manage-two
          isFromUserDeatil
          :detailPhone="$route.query.detailPhone"
        />
      </el-tab-pane>
      <el-tab-pane label="充电包月记录">
        <UserManageDetailThree ref="chargeMonthlyRecordRef" />
      </el-tab-pane>
      <el-tab-pane label="充电记录">
        <user-manage-detail-one />
      </el-tab-pane>
      <el-tab-pane label="充值记录">
        <user-manage-detail-two />
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="monthDialog"
      title="开通充电包月"
      @close="handleOpenMonthDialogClose"
    >
      <el-form
        ref="params"
        :model="monthForm"
        :rules="rules"
        :validate-event="false"
        label-width="auto"
      >
        <!-- <el-form-item label="分组设备">
          <el-select
              v-model="id"
              :loading="loading"
              :remote-method="fetchDevice"
              filterable
              placeholder="请输入设备名"
              remote
              reserve-keyword
              @change="change">
            <el-option
                v-for="(item,index) in options"
                :key="index"
                :label="item.name"
                :value="item.id"/>
          </el-select>
        </el-form-item> -->
        <el-form-item label="包月小区">
          <el-select
            v-model="id"
            :loading="loading"
            :remote-method="fetchGroup"
            filterable
            ref="select"
              @focus="closeReadOnly"
              @hook:mounted="closeReadOnly"
              @visible-change="closeReadOnly"
            placeholder="请输入小区名称"
            remote
            reserve-keyword
            @change="handleDeviceGroupChange"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.groupName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="包月套餐" prop="monthlyInfoId">
          <el-select
            v-model="monthForm.monthlyInfoId"
            :disabled="checked"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in monthlyInfoList"
              :key="item.id"
              :label="
                item.money +
                '元' +
                ' \/ ' +
                item.freeChargeNum +
                '小时，最大功率' +
                item.endPower +
                'W'
              "
              :value="item.id"
            >
              <span>{{
                item.money +
                "元" +
                " \/ " +
                item.freeChargeNum +
                "小时，最大功率" +
                item.endPower +
                "W"
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包月数量">
          <el-input-number
            v-model="monthForm.openMonthNum"
            :min="1"
            :max="12"
          ></el-input-number>
          个月
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="monthDialog = false">取消</el-button>
        <el-button type="primary" @click="postData()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UserManageTwo from "@/views/UserManage/UserManageTwo";

import agentGetOnlyChargeDeviceGroupIdNameList from "@/api/device/device-group-manage/agentGetOnlyChargeDeviceGroupIdNameList";
import agentOpenedAVipForWeChat from "@/api/device/member-monthly-manage/agentOpenedAVipForWeChat";
import getMonthlyByDeviceGroupId from "@/api/device/monthly-manage/getMonthlyByDeviceGroupId";
import agentGetWeChatUserInfo from "@/api/user/we-chat-user-manage/agentGetWeChatUserInfo";
import createdMixin from "@/mixin/createMixin";
import dialogMixin from "@/mixin/dialogMixin";
import getAllDevice from "@/mixin/getAllDeviceMixin";
import resDispose from "@/mixin/resDisposeMixin";
import timeMixin from "@/mixin/timeMixin";
import UserManageDetailOne from "./UserManageDetailOne";
import UserManageDetailThree from "./UserManageDetailThree";
import UserManageDetailTwo from "./UserManageDetailTwo";

export default {
  name: "UserManageDetail",
  components: {
    UserManageDetailTwo,
    UserManageDetailOne,
    UserManageDetailThree,
    UserManageTwo,
  },
  mixins: [dialogMixin, timeMixin, createdMixin, resDispose, getAllDevice],
  data() {
    return {
      rules: {
        monthlyInfoId: [{ required: true, message: "请选择包月套餐" }],
      },
      monthDialog: false,
      userInfo: {
        id: undefined,
        nickName: undefined,
        creatTime: undefined,
        money: undefined,
        grandTotalChargedNum: undefined,
        grandTotalMoney: undefined,
        headImage: undefined,
      },
      monthForm: {
        memberType: 1,
        memberId: this.$route.params.id,
        monthlyInfoId: undefined,
        openMonthNum: 1,
      },
      records: [
        {
          id: undefined,
          name: undefined,
        },
      ],
    };
  },
  methods: {
    closeReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner"); 
          input.removeAttribute("readonly"); 
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    handleDeviceGroupChange(val) {
      getMonthlyByDeviceGroupId(val).then((res) => {
        if (res.data.length === 0) {
          this.monthlyInfoList = [
            {
              id: null,
              freeDayNum: null,
              freeChargeNum: null,
              startPower: null,
              endPower: null,
              money: null,
            },
          ];
          this.monthForm.monthlyInfoId = undefined;
          this.checked = true;
        } else {
          this.monthlyInfoList = res.data;
          this.checked = false;
        }
      });
    },
    fetchGroup(query) {
      if (query !== "") {
        this.loading = true;
        agentGetOnlyChargeDeviceGroupIdNameList({ name: query }).then((res) => {
          this.options = res.data;
          this.loading = false;
        });
      } else {
        this.options = [];
      }
    },
    fetchData() {
      agentGetWeChatUserInfo(this.$route.params.id).then((res) => {
        this.userInfo = res.data;
      });
    },
    addMonth() {
      this.monthDialog = true;
      this.fetchGroup();
    },
    postData() {
      this.$refs["params"].validate((valid) => {
        if (valid) {
          agentOpenedAVipForWeChat(this.monthForm).then((res) => {
            this.resDispose({
              res,
              success: () => {
                // 重新获取用户充电包月记录
                if (this.$refs["chargeMonthlyRecordRef"]) {
                  this.$refs["chargeMonthlyRecordRef"].fetchData &&
                    this.$refs["chargeMonthlyRecordRef"].fetchData();
                }
                this.monthDialog = false;
              },
            });
          });
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    handleOpenMonthDialogClose() {
      this.id = null;
      this.monthForm.monthlyInfoId = undefined;
      this.$nextTick(() => {
        this.$refs["params"].clearValidate("monthlyInfoId");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .card {
    flex-wrap: wrap;

    div:first-child {
      flex-basis: 100% !important;

      img {
        width: 100%;
        border-radius: 50%;
      }
    }

    div:last-child {
      flex-basis: 100% !important;

      div {
        margin-top: 20px;
      }
    }
  }
}

.card {
  display: flex;

  div:first-child {
    flex-basis: 10%;
    margin-right: 15px;

    img {
      width: 100%;
      border-radius: 50%;
    }
  }

  div:last-child {
    flex-basis: 70%;

    div {
      margin-top: 20px;
    }
  }
}

.dredge {
  color: #528dcf;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-row {
  margin: 10px 0;
}

.their {
  margin-left: 30px;
}
</style>
